const base = {
    trackBatches: false,
    trackExpiry: false,
    trackSerials: false,
    allowNegativeStock: false,
    defaultPriceMode: 'RETAIL',
};
export const BUSINESS_TYPE_TEMPLATES = [
    {
        code: 'RETAIL',
        name: 'Retail Shop',
        description: 'Counter sales with a single or small number of locations.',
        suggestedFeatures: ['POS', 'PROMOTIONS'],
        defaults: { ...base },
    },
    {
        code: 'SUPERMARKET',
        name: 'Supermarket',
        description: 'High-volume retail with fast-moving goods and expiry dates.',
        suggestedFeatures: ['POS', 'PROMOTIONS', 'BATCH_EXPIRY', 'MULTI_WAREHOUSE'],
        defaults: { ...base, trackBatches: true, trackExpiry: true },
    },
    {
        code: 'WHOLESALE',
        name: 'Wholesale',
        description: 'Bulk sales with tiered pricing and credit customers.',
        suggestedFeatures: ['ADVANCED_PRICING', 'MULTI_WAREHOUSE'],
        defaults: { ...base, defaultPriceMode: 'WHOLESALE' },
    },
    {
        code: 'DISTRIBUTION',
        name: 'Distribution',
        description: 'Warehousing and delivery to a network of resellers.',
        suggestedFeatures: ['MULTI_WAREHOUSE', 'DELIVERY', 'ADVANCED_PRICING'],
        defaults: { ...base, defaultPriceMode: 'WHOLESALE' },
    },
    {
        code: 'PHARMACY',
        name: 'Pharmacy',
        description: 'Regulated goods with batch numbers and expiry control.',
        suggestedFeatures: ['POS', 'BATCH_EXPIRY'],
        defaults: { ...base, trackBatches: true, trackExpiry: true },
    },
    {
        code: 'HARDWARE',
        name: 'Hardware Store',
        description: 'Building materials sold in mixed units of measure.',
        suggestedFeatures: ['POS', 'ADVANCED_PRICING'],
        defaults: { ...base },
    },
    {
        code: 'ELECTRONICS',
        name: 'Electronics Store',
        description: 'Serialised goods with warranties and after-sales support.',
        suggestedFeatures: ['POS', 'SERIAL_NUMBERS', 'WARRANTY'],
        defaults: { ...base, trackSerials: true },
    },
    {
        code: 'RESTAURANT',
        name: 'Restaurant / Cafe',
        description: 'Menus and recipes that consume ingredient stock.',
        suggestedFeatures: ['POS', 'RESTAURANT', 'DELIVERY'],
        defaults: { ...base, allowNegativeStock: true },
    },
    {
        code: 'MANUFACTURING',
        name: 'Manufacturing',
        description: 'Raw materials converted into finished goods.',
        suggestedFeatures: ['MANUFACTURING', 'MULTI_WAREHOUSE'],
        defaults: { ...base, trackBatches: true },
    },
    {
        code: 'SERVICES',
        name: 'Services',
        description: 'Service lines invoiced with little or no stock.',
        suggestedFeatures: [],
        defaults: { ...base, allowNegativeStock: true },
    },
    {
        code: 'OTHER',
        name: 'Other',
        description: 'Start from a blank configuration.',
        suggestedFeatures: [],
        defaults: { ...base },
    },
];
export const BUSINESS_TYPE_CODES = BUSINESS_TYPE_TEMPLATES.map((t) => t.code);
export function findBusinessTypeTemplate(code) {
    return BUSINESS_TYPE_TEMPLATES.find((t) => t.code === code);
}
//# sourceMappingURL=business-types.js.map